/**
 * @generated SignedSource<<152f96503a7c752bffc47ab48c477760>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userLocationFragment$data = {
  readonly city: string | null;
  readonly state: string | null;
  readonly countryId: string | null;
  readonly " $fragmentType": "userLocationFragment";
};
export type userLocationFragment$key = {
  readonly " $data"?: userLocationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userLocationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userLocationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryId",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "c5d4bf5ad0aca056b2e5ed9a342c0259";

export default node;
